import axios from 'axios'
import { fetchEvn, api, getSign } from '../utils/utils'
import Qs from 'qs'
import { isMiniApplets } from './browser'
import { getQueryString } from './utils'
// import { dataCode } from './dataCode'

/**
 * 验签
 * @param {*} url 
 * @param {*} data 
 * @param {*} method 
 * @param {*} token
 */
function _getSign(url, data, method) {
  let { header } = getSign(url, method, data)
  return header
}

// 创建axios实例
let service = axios.create({
  baseURL: api[fetchEvn()], // 
  timeout: 10000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use((config) => {
  // config.headers = dataCode(config.data);
  config.headers["Content-Type"] = "application/json;charset=UTF-8"
  config.headers["X-APP-KEY"] = "ZUUL_H5_KEY"

  let url = config.url
  let data = config.data
  let method = config.method

  if (config.url === '/ehs/tools/general/support/url-link' || config.url === '/ehs/tools/merchant/general/support/url-link') {
    const signHeaders = _getSign(url, data, method)
    config.headers = { ...config.headers, ...signHeaders }
  }

  return config
}, (error) => {
  console.log(error) // for debug
  return Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  (response) => {
    return response.data;
  }, (error) => {
    return Promise.reject(error)
  }
)

const fetch = (opts, data) => {
  if (isMiniApplets() == 'wechat') {
    data.platform = 1
  } else {
    data.platform = 0
  }
  let httpDefaultOpts = {
    method: opts.method || 'get',
    url: opts.url,
    timeout: opts.timeout || 10000,
    params: data,
    data: data,
    headers: opts.method === 'get' ? {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    } : {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=UTF-8'
    }
  }

  if (opts.method === 'get') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }

  let promise = new Promise(function (resolve, reject) {
    service(httpDefaultOpts).then(
      (res) => {
        resolve(res)
      }
    ).catch(
      (err) => {
        reject(err)
      }
    )
  })
  return promise
}
export default fetch


